import React from "react";
import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import { Tabs, Row } from "antd";
import SendNotificationForm from "./Components/SendNotificationForm";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import Endpoints from "../../api/endpoints";
import { IoSendOutline } from "react-icons/io5";

const SendNotification = () => {
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const axiosPrivate = useAxiosPrivate();

  const [topicsMenu, setTopicsMenu] = useState([]);
  const [isTopicsLoading, setIsTopicsLoading] = useState(false);

  useEffect(() => {
    fetchTopicData();
  }, []);

  const fetchTopicData = async () => {
    setIsTopicsLoading(true);

    const result = await EndpointFunctions.fetchData({
      endpointURL: Endpoints.getAppNotificationsTopics,
      axiosPrivate: axiosPrivate,
    });

    if (result.success) {
      const formattedData = result.data.map((topic) => {
        return { value: topic.topicName, label: topic.topicName };
      });
      setTopicsMenu(formattedData);
      setIsTopicsLoading(false);
    } else {
      setIsTopicsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <>
      <Tabs defaultActiveKey="notification" centered>
        <Tabs
          tab={
            <Row align={"middle"}>
              <IoSendOutline style={{ fontSize: "18px", marginRight: 8 }} />
              Bildirim Gönder
            </Row>
          }
          key="notification">
          <SendNotificationForm
            topicsMenu={topicsMenu}
            isTopicsLoading={isTopicsLoading}
          />
        </Tabs>
      </Tabs>

      <ModalComponent></ModalComponent>
    </>
  );
};

export default SendNotification;
